export default __webpack_public_path__ + "static/media/NotoSansJP-Regular.2a77d217.ttf";